<template>
    <div class="admin-personalsearch">
        <el-card class="box-card">
            <template #header>
                <div class="logo-header">
                    <span class="ta-left">Deutsches Rotes Kreuz<br>Hurricane Festival 2026<br>Sanitäts- und Rettungsdienst</span>
                    <div>
                        <img src="../../assets/logo-drk.svg" class="logo-image"/>
                        <br>
                        <el-button type="danger" @click="logout">Abmelden</el-button>
                        <br>
                        <router-link to="/admin/dashboard">
                            <el-button type="primary" style="margin-top: 5px;">Zurück zum Admin-Dashboard</el-button>
                        </router-link>
                        <br>
                        <password/>
                    </div>
                </div>
            </template>
            <el-card>
                <template #header>
                    <div class="card-header">
                        <h2>Helfer suchen</h2>
                        <el-input
                            v-model="search"
                            placeholder="Suche nach Name, E-Mail oder Einheit"
                            clearable
                            style="max-width: 400px;"
                        />
                    </div>
                </template>
                <el-table
                    :data="filteredHelpers"
                    stripe
                    style="width: 100%"
                    height="600"
                    v-loading="loading"
                >
                    <el-table-column prop="name" label="Name" sortable min-width="180">
                        <template #default="{ row }">{{ row.firstname }} {{ row.name }}</template>
                    </el-table-column>
                    <el-table-column prop="email" label="E-Mail" sortable min-width="220"/>
                    <el-table-column prop="unit" label="Einheit" sortable min-width="180"/>
                    <el-table-column prop="professionalValue" label="Fachqualifikation" sortable min-width="160">
                        <template #default="{ row }">{{ mapProfessional(row.professionalValue) }}</template>
                    </el-table-column>
                    <el-table-column label="Aktionen" width="120">
                        <template #default="{ row }">
                            <el-button type="primary" size="small" @click="handleEdit(row)">Bearbeiten</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div style="margin-top: 10px; color: #909399; font-size: 13px;">
                    {{ filteredHelpers.length }} von {{ helpers.length }} Helfern
                </div>
            </el-card>
        </el-card>
    </div>
</template>

<script>
import Axios from "axios";
import { ElNotification } from "element-plus";
import Password from "@/components/password.vue";
import { normalizeProfessional } from "@/utils/normalize.js";

export default {
    name: "AdminPersonalSearch",
    components: { Password },
    data() {
        return {
            helpers: [],
            search: '',
            loading: false,
        };
    },
    computed: {
        filteredHelpers() {
            const q = this.search.trim().toLowerCase();
            if (!q) return this.helpers;
            return this.helpers.filter(h => {
                return (
                    (h.firstname || '').toLowerCase().includes(q) ||
                    (h.name || '').toLowerCase().includes(q) ||
                    (h.email || '').toLowerCase().includes(q) ||
                    (h.unit || '').toLowerCase().includes(q)
                );
            });
        },
    },
    methods: {
        logout() {
            this.$store.dispatch('logout');
            this.$router.push('/');
        },
        mapProfessional(value) {
            switch (normalizeProfessional(value)) {
                case 'eh': return 'Erste Hilfe';
                case 'san': return 'SAN';
                case 'rh': return 'Rettungshelfer';
                case 'rs': return 'Rettungssanitäter';
                case 'ra': return 'Rettungsassistent';
                case 'nfs': return 'Notfallsanitäter';
                case 'arzt': return 'Arzt';
                default: return '';
            }
        },
        async loadHelpers() {
            this.loading = true;
            try {
                const response = await Axios.get(`${process.env.VUE_APP_API_URL}/api/admin/personalsearch`);
                this.helpers = response.data.data || [];
            } catch (error) {
                ElNotification({
                    title: 'Fehler',
                    message: error.response?.data?.message || 'Helfer konnten nicht geladen werden',
                    type: 'error',
                });
            } finally {
                this.loading = false;
            }
        },
        handleEdit(row) {
            this.$router.push(`/admin/helferedit/${row.id}`);
        },
    },
    async created() {
        if (!this.$store.getters.isLoggedIn) {
            this.$router.push('/');
            return;
        }
        if (this.$store.getters.getRole !== 99) {
            this.$router.push('/unitdashboard');
            return;
        }
        this.loadHelpers();
    },
};
</script>

<style scoped>
.admin-personalsearch {
    display: flex;
    align-items: center;
    justify-content: center;
}

.box-card {
    max-width: 1100px;
    flex: auto;
}

.logo-image {
    width: 200px;
    display: flex;
}

.logo-header {
    justify-content: space-between;
    display: flex;
}

.ta-left {
    text-align: left;
}

.card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 20px;
}
</style>
